import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  toggleButton: {
    marginLeft: theme.spacing(-0.625),
    color: theme.palette.text.secondary,
    textTransform: 'none',
  },
  chevron: {
    transition: theme.transitions.create('transform'),
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
  },
  link: {
    color: palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

export default styles
